import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationLinear: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationLinear"><Path d="M3.5 20.5L20.5 3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationLinear;
